import GuideButtonArea from './ButtonArea/GuideButtonArea';
import GuideDescription from './Description/GuideDescription';
import Guide from './Guide';
import GuideImageArea from './ImageArea/GuideImageArea';
import GuideTextArea from './TextArea/GuideTextArea';
import GuideTitle from './Title/GuideTitle';

Guide.ImageArea = GuideImageArea;
Guide.Title = GuideTitle;
Guide.Description = GuideDescription;
Guide.TextArea = GuideTextArea;
Guide.ButtonArea = GuideButtonArea;
export default Guide;
